import React from 'react';
import Header from "../components/header/Header";
import SingleSkeletonProduct from "./skeletonProductSlider/SingleSkeletonProduct";
import Footer from "../components/footer/Footer";

const SkeletonProducts = () => {
    return (
        <div className="skeleton-products-wrapper">
            <Header/>
            <div className="container">
                <div className="filter-options-sk br-4 skeleton-loading d-flex align-items-center justify-content-between xpx-6 xmt-20">
                    <div className="text-sk br-4 text--1 skeleton-loading"></div>
                    <div className="text-sk br-4 text--2 skeleton-loading"></div>
                </div>
                <div className="products-item xmt-4">
                    <div className="row">
                        <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-4 col-6 xmt-6">
                            <SingleSkeletonProduct color="blue"/>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-4 col-6 xmt-6">
                            <SingleSkeletonProduct color="blue"/>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-4 col-6 xmt-6">
                            <SingleSkeletonProduct color="purple"/>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-4 col-6 xmt-6">
                            <SingleSkeletonProduct color="blue"/>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-4 col-6 xmt-6">
                            <SingleSkeletonProduct color="blue"/>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-4 col-6 xmt-6">
                            <SingleSkeletonProduct color="gray"/>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-4 col-6 xmt-6">
                            <SingleSkeletonProduct color="blue"/>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-4 col-6 xmt-6">
                            <SingleSkeletonProduct color="blue"/>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-4 col-6 xmt-6">
                            <SingleSkeletonProduct color="blue"/>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-4 col-6 xmt-6">
                            <SingleSkeletonProduct color="blue"/>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-4 col-6 xmt-6">
                            <SingleSkeletonProduct color="blue"/>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-4 col-6 xmt-6">
                            <SingleSkeletonProduct color="blue"/>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    );
};

export default SkeletonProducts;
